import { render, staticRenderFns } from "./MonitoringCh.vue?vue&type=template&id=3706dd77"
import script from "./MonitoringCh.vue?vue&type=script&lang=js"
export * from "./MonitoringCh.vue?vue&type=script&lang=js"
import style0 from "./MonitoringCh.vue?vue&type=style&index=0&id=3706dd77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports